<button class="m-icon-button"
        :class="{ 'm--is-skin-light': isSkinLight,
               'm--is-skin-link': isSkinLink,
               'm--is-skin-dark': isSkinDark,
               'm--is-skin-primary': isSkinPrimary,
               'm--is-skin-secondary': isSkinSecondary,
               'm--is-skin-bold': isSkinBold,
               'm--has-ripple': ripple,
               'm--is-disabled': disabled }"
        :disabled="disabled"
        type="button"
        :title="title"
        :style="{ width: buttonSize, height: buttonSize }"
        @click="onClick"
        @focus="onFocus"
        @blur="onBlur"
        @keydown="onKeydown">
    <m-icon ref="icon"
            class="m-icon-button__icon"
            :name="iconName"
            :size="iconSize" />
    <span v-if="$slots.default" class="m-icon-button__hidden">
        <slot />
    </span>
</button>
